import { SkeletonRect } from '../SkeletonRect';
import styles from './SkeletonFilters.css';

export const SkeletonFilters = () => {
  return (
    <div className={styles['skeleton-filters']}>
      {Array.from({ length: 7 }, (_, index) => (
        <SkeletonRect key={index} height="100%" borderRadius={8} />
      ))}
    </div>
  );
};
